import { RESPONSE_STATUS, RESPONSE_STATUS_JA, LANGUAGE } from '../../../constants';
import type { ProcessCellCallbackParams } from '../../../types/common';
import type { Language, SelectOption } from '../../../types/common';

const responseStatusCellCallback = (params: ProcessCellCallbackParams): string => {
  const value = params.value;
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const formattedValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? RESPONSE_STATUS_JA[value] : RESPONSE_STATUS[value]) : value;
  return formattedValue;
};

export default responseStatusCellCallback;
